import TotalTBCard from './TotatTBCard';

export default TotalTBCard;
